import { KalturaBaseEntry } from "kaltura-typescript-client/api/types/KalturaBaseEntry";

export enum EditPlaylistTabs {
    CONTENT = "content",
    INFO = "info",
}

export type MediaType = {
    entry: KalturaBaseEntry & { duration?: number };
    showDurationOnThumbnail: boolean;
    entryTypeName: string;
    uniqueId?: string;
    userDisplayName: string;
};
